import { render } from "./listResidence.vue?vue&type=template&id=0a7afc18&scoped=true"
import script from "./listResidence.vue?vue&type=script&lang=js"
export * from "./listResidence.vue?vue&type=script&lang=js"

import "./listResidence.vue?vue&type=style&index=0&id=0a7afc18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7afc18"]])

export default __exports__